import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AppConstants } from '@app/@core/entities/app-constants';
import { AuthService } from '@app/@core/services/auth.service';
import { AlertService } from '@core/services/alert.service';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs';
import { MailTemplateService } from './services/mail-template.service';
declare const $: any;
@Component({
  standalone: false,
  selector: 'app-mail-template',
  templateUrl: './mail-template.component.html',
  styleUrls: ['./mail-template.component.scss']
})
export class MailTemplateComponent implements OnInit {
  @Input() inputData: any;
  email = '';
  referralId = '';
  convertToZip = false;
  additionalDocuments = false;
  checked = false;
  email_template = '';
  packetId = '';
  document_packet_data: any = [];
  selectPacketName = '';
  emailTemplate: any = [];
  selectTemplate = '';
  isValidateRefferalid = false;
  referralAutoSuggestion = false;
  originalRefferalid = '';
  allEmailTemplateCategories: any = [];
  mailTempalateForm!: UntypedFormGroup;
  referralAutoList: any = [];
  mailePacketInput: any;
  missingCategoryList: any = [];
  orgSubs: Subscription;
  orgId: any;
  pageList: any = [];
  constructor(
    private _mailTemplateService: MailTemplateService,
    private _alertService: AlertService,
    private _formBuilder: UntypedFormBuilder,
    public auth: AuthService
  ) {
    this.getAllEmailTemplateCategories();
    this.getEmailTemplateNewList();
  }

  ngOnInit(): void {
    this.orgSubs = this.auth.orgInfo.subscribe(o => {
      this.orgId = o;
      console.log(this.orgId, 'mail template component');
    });
    this.inititlize();
    this.getPacketListing();
    this.getAllPages();
  }

  getAllPages() {
    this._mailTemplateService.getallPages(`${this.orgId}`, { pageTypes: ['ATPBDM', 'FFP'] }).subscribe((res: any) => {
      console.log(res);
      if (res && res.data) {
        this.pageList = res.data;
      }
    });
  }

  changePage(_e) {
    const data = this.mailTempalateForm.getRawValue();
    console.log(this.mailTempalateForm.controls['page'].value, data['page']);
  }

  inititlize() {
    this.mailTempalateForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.pattern('^[0-9a-zA-Z.-]+[@][0-9a-zA-Z.-]+[.][0-9a-zA-Z]{2,}$')]],
      page: ['', [Validators.required]],
      responseid: ['', [Validators.required]],
      selectPacketName: ['', [Validators.required]],
      selectTemplate: ['', [Validators.required]],
      convertToZip: false,
      additionalDocuments: false
    });
  }
  get mailTempalateFormControl() {
    return this.mailTempalateForm.controls;
  }

  getPacketListing() {
    this._mailTemplateService.getPacketListing().subscribe((res: any) => {
      if (res) {
        this.document_packet_data = [];
        this.document_packet_data = res.data;
        this.openMailPacket();
      }
    });
  }
  validatePacket() {
    const inputRequest = {
      responseid: this.mailTempalateForm.value.responseid ? this.mailTempalateForm.value.responseid : '',
      packetId: this.packetId,
      pageid: this.mailTempalateForm.value.page
    };
    this.missingCategoryList = [];
    this._mailTemplateService.mailattachmentsValidation(inputRequest).subscribe(
      (res: any) => {
        if (res && res.data.length > 0) {
          this.missingCategoryList = res.data;
        }
      },
      _err => {
        this._alertService.error(AppConstants.errorMessage);
      }
    );
  }
  confirmPacketMail() {
    this.mailePacketInput = {
      responseid: this.mailTempalateForm.value.responseid ? this.mailTempalateForm.value.responseid : '',
      pageid: this.mailTempalateForm.value.page,
      packetId: this.packetId,
      email: this.mailTempalateForm.value.email ? this.mailTempalateForm.value.email : '',
      convertToZip: this.mailTempalateForm.value.convertToZip ? this.mailTempalateForm.value.convertToZip : false,
      additionalDocuments: this.mailTempalateForm.value.additionalDocuments
        ? this.mailTempalateForm.value.additionalDocuments
        : false,
      email_template: this.email_template
    };
    const validate = this.validation();
    if (validate) {
      this.closeMailPacket();
      this._mailTemplateService.mailSent(this.mailePacketInput).subscribe(
        (_res: any) => {
          this._alertService.success('Mail sent successfully!');
        },
        _err => {
          this._alertService.error(AppConstants.errorMessage);
        }
      );
    }
  }
  validation(): any {
    if (!this.isValidateRefferalid) {
      this._alertService.warn('Please Search And Select Referral Id');
      return false;
    }
    if (this.packetId === '') {
      this._alertService.warn('Please select a packet!');
      return false;
    }
    if (this.mailTempalateForm.value.email === '') {
      this._alertService.warn('Email should not be empty!');
      return false;
    }
    if (this.email_template === '') {
      this._alertService.warn('Please select a email template!');
      return false;
    }
    if (this.mailTempalateForm.invalid) {
      this._alertService.warn('Please enter all required fields!');
      return false;
    }
    this._alertService.warn('Mail triggered successfully,it will take time to delivered!');
    return true;
  }
  checkCondition(data): any {
    if (data) {
      return data.length > 0 ? true : false;
    } else {
      return false;
    }
  }
  selectMailId(data) {
    this.packetId = data.id;
    if (!this.isValidateRefferalid) {
      this._alertService.warn('Please Search And Select Referral Id');
    } else {
      this.validatePacket();
    }
  }
  openMailPacket() {
    $('#mail-packet').modal('show');
    setTimeout(function () {
      $('body').removeClass('modal-open');
      $('.modal-backdrop').hide();
    }, 900);
  }
  closeMailPacket() {
    $('#mail-packet').modal('hide');
  }
  selectedTemp(data) {
    this.email_template = data.id ? data.id : '';
  }
  getAllEmailTemplateCategories() {
    this._mailTemplateService.getAllEmailTemplateCategories().subscribe((res: any) => {
      if (res) {
        this.allEmailTemplateCategories = [];
        this.allEmailTemplateCategories = res.data;
        this.allEmailTemplateCategories = this.allEmailTemplateCategories.filter(x => x.key === 'REFERRAL');
      }
    });
  }
  getEmailTemplateList() {
    const id = this.allEmailTemplateCategories.length > 0 ? this.allEmailTemplateCategories[0].id : 1;
    this._mailTemplateService.getEmailTemplateList(id).subscribe((res: any) => {
      if (res) {
        this.emailTemplate = res.data;
      }
    });
  }
  getEmailTemplateNewList() {
    this._mailTemplateService.getEmailTemplateNewList().subscribe((_res: any) => {
      if (_res) {
        this.emailTemplate = _res.data;
      }
    });
  }
  changeReferral() {
    this.isValidateRefferalid = false;
  }
  onKeyUp($event) {
    if (($event.target as HTMLInputElement).value) {
      const data = {
        responseid: ($event.target as HTMLInputElement).value,
        pageid: this.mailTempalateForm.value.page
      };
      if (data.responseid.length > 0 && data.pageid) {
        this._mailTemplateService
          .getResponseSuggesstions(data)
          .pipe(debounceTime(2000))
          .subscribe((res: any) => {
            if (res.data) {
              this.referralAutoList = res.data;
              this.referralAutoSuggestion = true;
              this.isValidateRefferalid = false;
            }
          });
      } else {
        this.referralAutoSuggestion = false;
      }
    }
  }
  selectAddrss(data) {
    this.isValidateRefferalid = true;
    this.referralAutoSuggestion = false;
    this.mailTempalateForm.patchValue({
      responseid: data.id
    });
    if (this.packetId !== '') {
      this.validatePacket();
    }
  }
  getCategoryList(): any {
    const subCat = this.missingCategoryList.filter((x: any) => x.category);
    return subCat.length > 0 ? subCat : [];
  }
  getSubCategory(subcate): any {
    const subCat = this.missingCategoryList.filter((x: any) => x.category === subcate.category);
    return subCat.length > 0 ? subCat[0].subcategory : [];
  }
}
